module.exports = __webpack_public_path__ + "static/media/kushner-fii.65c69887.png";